<template>
  <div>
    <CommonHeader />
    <slot></slot>
    <CommonFooter />
  </div>
</template>

<script>
import CommonHeader from "../../components/pc/CommonHeader";
import CommonFooter from "../../components/pc/CommonFooter";
export default {
  components: {
    CommonHeader,
    CommonFooter,
  },
  name: "Wrapper",
};
</script>



// WEBPACK FOOTER //
// src/components/pc/Wrapper.vue